

export const symbols = [ 'GOOGL', 'TSLA'];
export const VOLUME_ALERT_BOUNDARY = 50;